import axios from 'axios';
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import './AddProduct.css'

function AddProducts() {

    const [formData, setFormData] = useState({
        department: '',
        category: '',
        description: '',
        productType: '',
        brand: '',
        color: '',
        size: '',
        actualPrice: '',
        discountedPrice: '',
        discount: '',
        quantity: ''
    });

    const [image, setImage] = useState(null);
    const [message, setMessage] = useState('');
    const navigate = useNavigate();


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleImageChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setImage(e.target.files[0]);
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        const data = new FormData();

        for (const key in formData) {
            data.append(key, formData[key]);
        }

        if (image) {
            data.append('image', image);
        }

        try {
            const response = await axios.post('http://localhost:3001/api/admin/products', data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                withCredentials: true
            });

            if (response.data.success) {
                setMessage({ text: 'Product added successfully!', type: 'success' });
                // Reset form
                setFormData({
                    department: '',
                    category: '',
                    description: '',
                    productType: '',
                    brand: '',
                    color: '',
                    size: '',
                    actualPrice: '',
                    discountedPrice: '',
                    discount: '',
                    quantity: ''
                });
                setImage(null);
                setTimeout(() => navigate('/admin'), 2000);
            }
        } catch (error) {
            console.error('Error:', error);
            setMessage({ text: error.response?.data?.message || 'Failed to add product', type: 'error' });
        }
    };


    return (
        <div className="add-product-container">
            <h2>Add New Product</h2>
            {message && (
                <div className={`form-message ${message.type}`}>
                    {message.text}
                </div>
            )}

            <form className="product-form" onSubmit={handleSubmit}>
                <div className="form-group">
                    <label>Department</label>
                    <input
                        type="text"
                        name="department"
                        value={formData.department}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label>Category</label>
                    <input
                        type="text"
                        name="category"
                        value={formData.category}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label>Description</label>
                    <textarea
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label>Product Type</label>
                    <input
                        type="text"
                        name="productType"
                        value={formData.productType}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label>Brand</label>
                    <input
                        type="text"
                        name="brand"
                        value={formData.brand}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label>Color</label>
                    <input
                        type="text"
                        name="color"
                        value={formData.color}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label>Size</label>
                    <input
                        type="text"
                        name="size"
                        value={formData.size}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label>Quantity in Stock</label>
                    <input
                        type="number"
                        name="quantity"
                        min="0"
                        value={formData.quantity}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="price-fields">
                    <div className="form-group">
                        <label>Actual Price</label>
                        <input
                            type="number"
                            name="actualPrice"
                            value={formData.actualPrice}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Discounted Price</label>
                        <input
                            type="number"
                            name="discountedPrice"
                            value={formData.discountedPrice}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-group">
                        <label>Discount (%)</label>
                        <input
                            type="number"
                            name="discount"
                            value={formData.discount}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="form-group">
                    <label>Product Image</label>
                    <input
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                    />
                </div>

                <button type="submit" className="submit-btn">
                    Add Product
                </button>
            </form>
        </div>
    )
}

export default AddProducts